"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseComponent_1 = require("../BaseComponent");
var HegydCore_1 = require("./hegyd/hegyd-core/HegydCore");
var toastr = require("toastr");
var Loader = /** @class */ (function (_super) {
    __extends(Loader, _super);
    function Loader($view) {
        var _this = _super.call(this, $view) || this;
        _this.bind();
        return _this;
    }
    Loader.prototype.bind = function () {
        this.initMegaMenu();
        this.initSearch();
        this.initWrapperPosition();
        this.initEvtListeners();
        this.accountDropDown();
    };
    Loader.prototype.initMegaMenu = function () {
        var self = this;
        var storeLocatorLink = this.$view.find('.store-locator-link');
        storeLocatorLink.on('click', function (e) {
            e.preventDefault();
            HegydCore_1.default.initRemoteModal('#modal-store', e.target.href, null, function (data) {
                if (data.shop_name) {
                    window.location.reload();
                }
                if (data.message) {
                    toastr.success(data.message);
                }
            });
        });
        if (storeLocatorLink.hasClass('open-store-locator')) {
            storeLocatorLink.trigger('click');
        }
        $(document).on('click', function (e) {
            if ($(e.target)[0].nodeName !== 'A') {
                $('.megamenu').each(function () {
                    $(this).hide();
                });
                $('header.topbar .overlay').removeClass('d-block');
            }
        });
        /**
        let nav = $('.main-nav ul li.category_link a');
        nav.on('mouseover', function (e) {
            e.preventDefault();
            if ($(window).width() > 967.98) {
                self.displayMenu($(this));
                $('header.topbar .overlay').addClass('d-block')
            }
        })
        nav.on('click', function (e) {
            e.preventDefault();
            if ($(window).width() < 967.98) {
                self.displayMenu($(this));
            }
        })
         */
        $('.megamenu').each(function () {
            var megaMenu = $(this);
            megaMenu.on('mouseleave', function (e) {
                if ($(window).width() > 967.98) {
                    megaMenu.hide();
                    $('header.topbar .overlay').removeClass('d-block');
                }
            });
        });
    };
    Loader.prototype.displayMenu = function (element) {
        var divInfo = $('#show-megamenu-' + element.data('id'));
        $('.megamenu').each(function () {
            $(this).hide();
        });
        divInfo.show();
    };
    Loader.prototype.initSearch = function () {
        this.$view.find("#search_form input").on("keydown", function search(e) {
            if (e.keyCode == 13) {
                $(this).parents('form').submit();
            }
        });
    };
    Loader.prototype.initWrapperPosition = function () {
        var wrapper = document.querySelector('.page-wrapper');
        var header = document.querySelector('header.topbar');
        wrapper.style.setProperty("margin-top", header.offsetHeight.toString() + "px", "important");
    };
    Loader.prototype.initEvtListeners = function () {
        var _this = this;
        window.addEventListener('resize', function () {
            _this.initWrapperPosition();
            _this.accountDropDown();
        });
    };
    Loader.prototype.accountDropDown = function () {
        var $dropdown = $(".header-account");
        var $dropdownMenu = $(".dropdown-menu");
        var showClass = "show";
        if (window.matchMedia("(min-width: 992px)").matches) {
            $dropdown.on('mouseenter', function () {
                var $this = $(this);
                $this.addClass(showClass);
                $this.find($dropdownMenu).addClass(showClass);
            }).on('mouseleave', function () {
                var $this = $(this);
                $this.removeClass(showClass);
                $this.find($dropdownMenu).removeClass(showClass);
            });
        }
        else {
            $dropdown.off("mouseenter mouseleave");
            $dropdown.on('click', function () {
                $dropdownMenu.toggleClass(showClass);
            });
        }
    };
    return Loader;
}(BaseComponent_1.default));
exports.default = Loader;
